import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';

@Component({
  selector: 'tt-consignment-shipments',
  templateUrl: './consignment-shipments.component.html',
  styleUrls: ['./consignment-shipments.component.css']
})
export class ConsignmentShipmentsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public itemsListShipments: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1101))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no_from });
    }

    private async loadShipments() {
        if (!this.setting) return;

        this.itemsListShipments = await this.datatask.Post(1102, this.setting);
    }

    private async updateStockPlace() {
        if (!this.setting) return;

        const response = (await this.datatask.Post(1103, { businessco_no_from: this.setting.businessco_no_from }))[0];

        this.setting.stockplace_id_from = response?.stockplace_id_from;

        this.loadShipments();
    }

    public onTabChange() {
        this.loadShipments();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_from':
                Promise.all([
                    this.loadStockPlaces()
                ]).then(() => {
                    this.updateStockPlace();
                    Promise.resolve();
                });
                break;
            case 'stockplace_id_from':
            case 'dateselector':
                this.loadShipments();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        this.loadShipments();
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        
        return Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadShipments();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no_from: string;
    stockplace_id_from: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    gb_consignmentshipment_status: string;
    filterval: string;
    dateselector: string;
}
